import Head from 'next/head';

import { capsulaUrl } from 'utils/links';

import { Header } from 'components/Header';

import * as S from './styles';

const Capsula: React.FC = () => {
  return (
    <>
      <Head>
        <title key="title">Lami ora è Capsula</title>

        <meta
          key="description"
          name="description"
          content="Lami ora è Capsula. Crea un account su Capsula e continua a utilizzare i servizi."
        />
      </Head>

      <Header />

      <S.Wrapper>
        <S.Card>
          <S.Title>Lami ora è Capsula</S.Title>

          <S.Body>
            Crea un account su Capsula e continua a utilizzare i servizi.
          </S.Body>

          <S.CTALink
            href={capsulaUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Accedi ora
          </S.CTALink>
        </S.Card>
      </S.Wrapper>
    </>
  );
};

export default Capsula;
